module.exports = __webpack_public_path__ + "img/Adobe_Creative_Cloud_Connected_lockup_horizontal.0f48786a.svg";